export default {
    setDepthChart(state, depthChart) {
        state.depthChart = depthChart;
    },
    setError(state, error) {
        state.error = error.toString();
    },
};
